import { useTenant } from "@/lib/tenant-context.js";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card.js";
import { Badge } from "@/components/ui/badge.js";

export function SettingsPage(): React.JSX.Element {
  const { me, profile, tenantSlug } = useTenant();
  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-lg font-semibold">Settings</h1>
      <Card>
        <CardHeader>
          <CardTitle>Tenant</CardTitle>
          <CardDescription>Read-only summary of the tenant context.</CardDescription>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-2 text-sm">
          <Field label="Slug" value={me?.tenant.slug ?? tenantSlug} />
          <Field
            label="Vertical"
            value={
              <Badge variant="outline" className="capitalize">
                {me?.tenant.vertical ?? "—"}
              </Badge>
            }
          />
          <Field label="User" value={me?.user.email ?? "—"} />
          <Field label="Role" value={me?.user.role ?? "—"} />
          <Field
            label="Default view"
            value={
              <Badge variant="outline" className="capitalize">
                {profile?.default_view ?? "grid"}
              </Badge>
            }
          />
          <Field label="Required customer fields" value={profile?.required_customer_fields.join(", ") || "—"} />
        </CardContent>
      </Card>
    </div>
  );
}

function Field({ label, value }: { label: string; value: React.ReactNode }): React.JSX.Element {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-xs uppercase text-muted-foreground">{label}</span>
      <span>{value}</span>
    </div>
  );
}
